import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { IDataService } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-ui-field-default-countries',
  templateUrl: './countries.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountriesComponent {
  @Input() data: any;
  public data$: any;

  constructor(@Inject('IDataService') private dataService: IDataService) {
    this.data$ = this.dataService.getData();
  }
}
